import HttpService from '../services/HttpService';

export const UPDATE_INSURANCES = 'update_insurances';

export const getSiteInsurances = (force = false) => {
  return (dispatch, getState) => {
    const state = getState();
    if (!force && state.InsurancesReducer.insurances.length > 0) {
      return;
    }

    return gSI().then((data) => {
      const insurances = data.insurances;
      dispatch({ type: UPDATE_INSURANCES, payload: insurances });
    });
  };
};

export const gSI = () => {
  return HttpService.get('/admin/insurances')
    .then((response) => response.json())
    .then((data) => data);
};
